import { useState, FC } from 'react';
import ImageWithOptionalCTA from '../ImageWithOptionalCTA/ImageWithOptionalCTA';
import transformImageWithOptionalCTA from '../../cms/component-transformers/imageWithOptionalCTA-transformer/imageWithOptionalCTA-transformer';
import type { FullScreenBannerProps } from './types/propsTypes';
import FullScreenModal from './FullScreenModal';
import styles from './FullScreenBanner.module.scss';

const FullScreenBanner: FC<FullScreenBannerProps> = (data) => {
  const [showModal, setShowModal] = useState(true);
  const onTextModalClose = () => {
    setShowModal(false);
  };
  const imageBannerCMSData = {
    image_with_optional_cta: data?.imageWithOptionalCtaData,
  };
  const imageWithOptionalCtaData = transformImageWithOptionalCTA(imageBannerCMSData);

  return (
    <div className={styles['full-screen-banner']} data-testid="full-screen-banner-container-id">
      {showModal && (
        <FullScreenModal onClose={onTextModalClose} data-testid="full-screen-banner-modal-id">
          <ImageWithOptionalCTA {...imageWithOptionalCtaData} />
        </FullScreenModal>
      )}
    </div>
  );
};

export default FullScreenBanner;
